import { render } from "./Imprint.vue?vue&type=template&id=57e5ac48"
const script = {}

import exportComponent from "C:\\Users\\Florian\\Desktop\\FeuerwehrWeb3\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__